
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earn",
      function () {
        return require("private-next-pages/earn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/earn"])
      });
    }
  